module.exports = __webpack_public_path__ + "./images/2.d1871d23e4ef5eeeafaf4ca8ec4ecf0b.png";